import React from 'react';
import Axios from 'axios';
import moment from 'moment';
import { withRouter } from "../withRouter"; 	// HOC pour React Router v6
import { ConnectedUserContext } from '../connectedUser-context';
import { Card, CardHeader, CardBody, CardFooter, Collapse, Tooltip } from 'reactstrap';
import SwipeHandler from '../tools/SwipeHandler';
import { formatDiffNumber, updatePlayerRatings, calculateScores } from './scoresheetUtils';
//import throttle from 'lodash/throttle';
import ScoresheetAddSubModal from './ScoresheetAddSubModal';

// À GÉRER
// .game et .round sont des idx qui commencent à 1 et qui ne sont pas ABSOLUMENT séquentiels, même si c'est le but
// quand on bâtit la feuille de pointage.  Faudrait gérer les erreurs potentielles sur ces index, vu qu'ils 
// sont utilisés comme index de tableaux..

// NOTE: Check if matchDetails.team1.players and matchDetails.team2.players are still necessary

// DEBUG
const CST_DEBUG_HIDE_MATCH_VALIDATION_BTN = false;
const CST_DEBUG_FORCE_PAT_RATING = '0';

const CST_SCREEN_LIMIT = 992;
const CST_NOPLAYER = "(joueur indéterminé)";

// TESTS on season 
// name: "A - AH2024 - Élite (4) - TRS 190"
// _id: "66bba7a4ecad69323892c879"
// seasonTag: "qvnea-ah2024-elite-4-trs-190"

// Last Elite Season
// _id : ObjectId("64ac31c45e39cd6b46fe0f76"),
// name : "QVNEA - AH2023 - Élite (4) - TRS 190"
// seasonTag: "qvnea-ah2023-elite-4-trs-190"

/*
// EXEMPLES DE SPINNER COOL
<div class="spinner-overlay-1">
  <div class="spinner-circle"></div>
</div>
*/
/*
<div class="spinner-overlay-2">
  <div class="spinner-dots">
    <div class="dot"></div>
    <div class="dot"></div>
    <div class="dot"></div>
  </div>
</div>
*/


// THIS SHOULD BE IN SEASON PARAMETERS or elsewhere in DB
// const CST_SPECIALPERFO_LIST = ['', 'ero', 'tablerun'];

// -----------------------------------------------------------------------
// Component: Scoresheet
class Scoresheet extends React.Component {

	static contextType = ConnectedUserContext;

  constructor(props) {
		super(props);

		this.state = {
			windowWidth: window.innerWidth,
			editorPlayer: {_id: "0", team: ""},

			match: {_id: "0"},
			matchDetails: {
				season: {}
			},
			scoresheetFormat: {},
			playerStats: [],
			teamStats: [],
			leftMostRoundIdxShown: 0,

			readOnly: true,
			editMode: false,
			multiEditMode: true,
			autoWinScoreMode: true,

			scoreValidationPopup: {	show: false, roundIdx: -1, matchupIdx: -1	},

			scrollArrowsVisible: true,
			savingScoreEdit: false,
			showMatchDatePicker: false,
      isTouchDevice: 'ontouchstart' in window || navigator.maxTouchPoints > 0,	
			loading: true,

			showSubModal: false,
			subRoundIdx: null,
			subMatchupIdx: null,
			subTeamIdx: null,

			hasNDratingMsgDisplayed: false,
			testsIamEveMode: false,
		};

		let scoreValueChanged = false
    this.scoreValidationPopupRef = React.createRef();
		this.showRound = this.showRound.bind(this);
	}

	// --------------------- Lifecycle ---------------------
	componentDidMount() {
		console.log('TAG componentDidMount');
		window.addEventListener('resize', this.handleResize);
		document.addEventListener('click', this.handleClickOutsidePopup, true);
		document.body.classList.add('sidebar-hidden');

	  const ctx = this.context?.connectedUser;
	  if (!ctx) return;   // Contexte pas encore prêt → on attend didUpdate

	  const playerId = ctx.user?.playerId ?? null;
		//const playerId = "000011112222333344445555";
	  const editorPlayer = { _id: playerId, team: "" };
	  this.getScoresheetInfo(this.props.params.seasonTag, this.props.params.ssIdx, editorPlayer);
	  this.prevHadUser = true;
	}

	componentDidUpdate() {
	  //console.log("TAG componentDidUpdate");
	  if (!this.prevHadUser && this.context.connectedUser) {
		  console.log("TAG componentDidUpdate (considered)");
	    const playerId = this.context.connectedUser.user?.playerId ?? null;
	    const editorPlayer = { _id: playerId, team: "" };
	    this.getScoresheetInfo(this.props.params.seasonTag, this.props.params.ssIdx, editorPlayer);
		  this.prevHadUser = true;
	  }
	}

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
    document.removeEventListener('click', this.handleClickOutsidePopup, true);
  }

  handleSwipeLeft = () => { this.handleRoundScroll(1); };
  handleSwipeRight = () => { this.handleRoundScroll(-1); };
  handleResize = () => {
  	const { windowWidth } = this.state;
		if ((windowWidth < CST_SCREEN_LIMIT) !== (window.innerWidth < CST_SCREEN_LIMIT)) {
	  	this.setState({ windowWidth: window.innerWidth });
		}
  }
  handleClickOutsidePopup = (e) => {
    // Si le clic est en dehors du popup et que le popup est visible, le fermer
    if (this.scoreValidationPopupRef.current && !this.scoreValidationPopupRef.current.contains(e.target)) {
      let { scoreValidationPopup } = this.state;
      scoreValidationPopup.show = false;
      this.setState({ scoreValidationPopup });
    }
  };

	refreshPlayersList = () => {
		console.log('TAG refreshPlayersList');

	  const { match } = this.state;
	  Axios.get(`/api/scoresheets2/playersList/${match._id}`)
	    .then(res => {
	      const matchPlayersList = res.data.matchPlayersList;

	      // console.log('%crefreshPlayersList: matchPlayersList', 'color: red;', matchPlayersList);

	      // 1) Prépare le nouvel objet matchDetails
	      const newMatchDetails = { ...this.state.matchDetails, matchPlayersList };

	      // 2) Un seul setState propre
	      this.setState(
	        { matchDetails: newMatchDetails },
	        () => {
	          // 3) Recalcule tout une fois matchPlayersList mis à jour
	          this.updateScores(this.state.match, newMatchDetails);
	        }
	      );
	    });
	};

	getScoresheetInfo(seasonTag, ssIdx, editorPlayer) {
		console.log("%cTAG getScoresheetInfo", 'color: red;')

		Axios.get(`/api/scoresheets2/seasonTag/${seasonTag}/ssIdx/${ssIdx}`)
		.then(responseScoresheet => {

			// Destructuration	
			let { match } = responseScoresheet.data;
			const { matchDetails, matchDetails: {matchPlayersList}, defaultScoresheetFormat } = responseScoresheet.data;

			const matchCopy = { ...match };
			console.log("getScoresheetInfo, matchCopy:", matchCopy.rounds[0].matchups[0].p1player[0])
			console.log("getScoresheetInfo, matchPlayersList:", matchPlayersList)

  		const editorPlayerInList = matchPlayersList.find(player => player._id === editorPlayer._id);
			editorPlayer.team = editorPlayerInList?.team || '';		// "A" or "B"

  		if (match.datePlayed === null) {
  			match.datePlayed = new Date();		// Set date played as TODAY
  			this.saveScoresheetParameters(match);
  		}

  		// CHECK ACCESS HERE
      Axios.get(`/api/scoresheets2/checkAccess/seasonTag/${seasonTag}/scoresheetId/${match._id}/playerId/${editorPlayer._id}`)
      .then(responseAccess => {
        // console.log("responseAccess.data", responseAccess.data);
        const { canEdit } = responseAccess.data;
		    const urlMode = this.props.params?.mode; // "edit" ou "view"
		    const readOnly = !canEdit || (urlMode === "view");

        // Got scoresheet data, now update scores, no save here, only state update
        this.updateScores(match, matchDetails, (updatedMatch) => {
	        this.setState({
	          editorPlayer,
	          matchDetails,
	          scoresheetFormat: defaultScoresheetFormat,
	          readOnly,
	          loading: false
	        });
        });
      })
		});
	}

	getPlayerName = (playerId) => {
	  const matchPlayersList = this.state.matchDetails?.matchPlayersList;

	  // Si la liste n'est pas encore chargée, on retourne la valeur par défaut
	  if (!matchPlayersList || !Array.isArray(matchPlayersList)) {
	    return CST_NOPLAYER;
	  }

	  // On compare en string pour éviter les soucis ObjectId vs string
	  const foundPlayer = matchPlayersList.find(
	    mp => mp._id?.toString() === playerId?.toString()
	  );

	  let playerName = CST_NOPLAYER;
	  if(foundPlayer) {
		  playerName = foundPlayer.name + (foundPlayer.isSub ? ' (SUB)' : '');
	  }

	  return playerName;
	}


  // Fonction pour basculer le mode édition
  toggleEditMode = () => {
    this.setState(prevState => ({
      editMode: !prevState.editMode
    }));
  }
  toggleMultiEditMode = () => {
    this.setState(prevState => ({
      multiEditMode: !prevState.multiEditMode
    }));
  }
  toggleAutoWinScoreMode = () => {
    this.setState(prevState => ({
      autoWinScoreMode: !prevState.autoWinScoreMode
    }));
  }
  toggleTestsIamEve = () => {
		let editorPlayer = {_id: "58544ee715f60d187fbf9ef2", team: "A"};
		this.setState(prevState => {
			const newTestsIamEveMode = !prevState.testsIamEveMode;
		  if (newTestsIamEveMode) {
		  	editorPlayer = {_id: "59e2013397f47a52360b9e81", team: "B"}
		  }
		  return {
		    testsIamEveMode: newTestsIamEveMode,
		    editorPlayer: editorPlayer
		  };
		});
  }

 	render() {
		console.log('TAG Scoresheet: RENDER');
		console.log("this.state", this.state);
		// console.log("this.props.params", this.props.params)

		const { loading, isTouchDevice } = this.state;
		return (
			<div className="ss2-container animated fadeIn row-margin-bottom-100">

				{!loading ? 
					<React.Fragment>
 						{this.showHeader()}
						{this.scrollButtons()}

						{isTouchDevice ? (
	          	<SwipeHandler onSwipedLeft={this.handleSwipeLeft} onSwipedRight={this.handleSwipeRight}>
								{this.showRounds()}
            	</SwipeHandler>
            	) : ( 
            	this.showRounds()
            )}

						<hr className="double-ss2"/>
						{this.showMatchSummaryA()}

						<div className="ss2-matchsum-dashed-line-container">
						<hr className="ss2-matchsum-dashed-line" />
						</div>

						{this.showMatchSummaryB()}
						<hr className="double-ss2"/>

						{!CST_DEBUG_HIDE_MATCH_VALIDATION_BTN 
							? this.showMatchValidation()
							: null
						}

					</React.Fragment>
					: null }

				{this.state.showSubModal && (
				  <ScoresheetAddSubModal
				    showModal={this.state.showSubModal}
				    handicapType={this.state.matchDetails.season.handicapType}
				    handleCancel={() => this.setState({ showSubModal: false })}
				    handleConfirm={this.handleSelectSubPlayer}
				  />
				)}

			</div>
		);
	}

	showHeader() {
		const { match, matchDetails, scoresheetFormat: { winPoints }, showMatchDatePicker, readOnly } = this.state;
		let dateScheduled = match.dateScheduled ? moment(match.dateScheduled).local().format("YYYY-MM-DD") : null;
		let datePlayed = match.datePlayed ? moment(match.datePlayed).local().format("YYYY-MM-DD") : null;

		return (
			<div className="ss2-header">
			<div className="row ss2-title">
			<div className="col-lg-12">
				<h4>Feuille de Pointage</h4>
			</div>
			</div>
			<hr className="double-ss2"/>

			<div className="row ss2-header-row">
			<div className="col-12 col-lg-4">
				<p className="small-margin">
					<strong>Ligue: </strong>{matchDetails.season.seasonName} <br/>
					<strong>Sous-saison: </strong>{matchDetails.season.subSeasonName} <br/>
					<strong>Programme: </strong>{match.week} <br/>
					<strong>Lieu: </strong>{matchDetails.locationName} <br/>
					<strong>ID (DEV ONLY): </strong><span className="ss2-ssid-userselect">{match._id} </span> <br/>
					<strong>NOTES (DEV ONLY):<br/>
					</strong> <span style={{ whiteSpace: 'pre-line' }}> {match.notes}	</span>
				</p>

				{!readOnly ? 
					<>
					<label className="switch switch-3d switch-sm switch-success form-control-label">
					<input type="checkbox" className="switch-input form-check-input" 
						checked={this.state.testsIamEveMode || false} onChange={this.toggleTestsIamEve}/>								
						<span className="switch-label"></span>
					<span className="switch-handle"></span>
					</label>
					&nbsp;&nbsp;Tests - I am Eve
					<br/>
					</>
					: null}

				<hr className="hr only-on-smallscreen"/>
			</div>

			<div className="col-12 col-lg-4">
				<p className="small-margin">
					<strong>Date cédulée: </strong>{dateScheduled} <br/>
					<strong>Date du match: </strong>

					{/* Show date picker and editable date, if allowed, else, show date only */}
				  {showMatchDatePicker && !readOnly ? (
				    <>
				      <input
				        type="date"
				        value={datePlayed}
				        onChange={(e) => this.handleMatchDateChange(e) }
				        onBlur={(e) => this.handleMatchDatePickerOnBlur(e) }
				        autoFocus
				      /><br/>
				    </>
				  ) : (
				    <>
				      <span>{datePlayed}</span>
				      {!readOnly && (
				        <span className="show-pointer" onClick={this.handleMatchDatePickClick}> 🖉</span>
				      )}
				      <br/>
				    </>
				  )}

					<strong># de Match: </strong>{match.ssIdx} <br/>
					<strong>Local: </strong>{matchDetails.team1name} <br/>
					<strong>Visiteur: </strong>{matchDetails.team2name}
				</p>
				<hr className="hr only-on-smallscreen"/>
			</div>

		  {!readOnly ? (
			<div className="col-12 col-lg-4">
				<label className="switch switch-3d switch-sm switch-success form-control-label">
				<input type="checkbox" className="switch-input form-check-input" 
					checked={this.state.editMode || false} onChange={this.toggleEditMode}/>								
					<span className="switch-label"></span>
				<span className="switch-handle"></span>
				</label>
				&nbsp;&nbsp;Mode édition
				<br/>

				<label className="switch switch-3d switch-sm switch-success form-control-label">
				<input type="checkbox" className="switch-input form-check-input" 
					checked={this.state.multiEditMode || false} onChange={this.toggleMultiEditMode}/>								
					<span className="switch-label"></span>
				<span className="switch-handle"></span>
				</label>
				&nbsp;&nbsp;Édition multiple (tous les rondes)
				<br/>

				{(winPoints !== 0) ? 
					<React.Fragment>
					<label className="switch switch-3d switch-sm switch-success form-control-label">
					<input type="checkbox" className="switch-input form-check-input" 
						checked={this.state.autoWinScoreMode || false} onChange={this.toggleAutoWinScoreMode}/>
						<span className="switch-label"></span>
					<span className="switch-handle"></span>
					</label>
					&nbsp;&nbsp;Pointage {winPoints} automatique
					<br/>
					</React.Fragment>
				: null}

				<input type="button" className="btn btn-sm btn-primary" value="↻" onClick={this.refreshMatch} /> &nbsp;&nbsp;
				<input type="button" className="btn btn-sm btn-primary" value="[T] Fill Teams" onClick={this.handleTestFillTeams} /> &nbsp;&nbsp;
				<input type="button" className="btn btn-sm btn-primary" value="[T] Set Scores" onClick={this.handleTestSetScores} /> &nbsp;&nbsp;

			</div> 
			) : null}

			</div>

			<hr className="double-ss2"/>
			</div>
		);

	}

	scrollButtons() {
		return (
			<div className="ss2-scrollArrows">
				<span className="ss2-roundscroll-btn ss2-roundscroll-btn-left"
					onClick={() => this.handleRoundScroll(-1)}> &lt; </span>
				<span className="ss2-roundscroll-btn ss2-roundscroll-btn-right"
					onClick={() => this.handleRoundScroll(1)}> &gt; </span>
			</div>
		);
	}

	showRounds() {
		// Destructuration
    const { windowWidth, scoresheetFormat: { rounds }, leftMostRoundIdxShown } = this.state;
    const roundsCount = windowWidth < CST_SCREEN_LIMIT ? 1 : Math.min(rounds.length, 3);
		return (
			<div className="ss2-rounds-container">
		   { rounds.map(this.showRound) }
			</div>
		);
	}

	showRound(round, roundIdx) {
    const { leftMostRoundIdxShown, match, scrollArrowsVisible } = this.state;
		var showLeftArrow = (scrollArrowsVisible && (roundIdx === leftMostRoundIdxShown));
		var showRightArrowSmallScreen = (scrollArrowsVisible && (roundIdx === leftMostRoundIdxShown));
		var showRightArrowLargeScreen = (scrollArrowsVisible && (roundIdx === leftMostRoundIdxShown + 2));

    let translatePercentage = -(100 * leftMostRoundIdxShown);

		return (
			<div className={"ss2-round-box"}
				style={{ transform: `translateX(${translatePercentage}%)` }} key={'roundContainer' + roundIdx}>

				<h4 className="ss2-round-title">Ronde {round.round}</h4>
				<hr className="ss2-hr-match"/>

				{/* Show matchups */}
				{ round.matchups.map((mu, muIdx) => this.showMatchup(roundIdx, muIdx)) }
				{this.showRoundSummary(roundIdx)}
			</div>
		)
	}

	showMatchup(roundIdx, matchupIdx) {
		const { readOnly, savingScoreEdit } = this.state;
		const { match, matchDetails, editMode, playerStats, editorPlayer, scoreValidationPopup } = this.state;

		const { matchPlayersList } = matchDetails;
		// Si matchPlayersList n'est pas prêt → on retourne des listes vides
		// const matchPlayersList = this.state.matchDetails?.matchPlayersList;
		// const safeMatchPlayersList = Array.isArray(matchPlayersList) ? matchPlayersList : [];

    let matchup = match.rounds[roundIdx].matchups[matchupIdx];
    let p1id = matchup.p1player[0].playerId;
    let p2id = matchup.p2player[0].playerId;
    let p1name = this.getPlayerName(p1id);
    let p2name = this.getPlayerName(p2id);

    const team1players = matchPlayersList.filter(mp => (mp.team === 'A'));
    const team2players = matchPlayersList.filter(mp => (mp.team === 'B'));
		// const team1players = safeMatchPlayersList.filter(mp => mp.team === 'A');
		// const team2players = safeMatchPlayersList.filter(mp => mp.team === 'B');

    let specBgEditClass = editMode ? " ss2-rnd-scorebox-score-greybg" : "";

    const defaultStats = {cumulWins: 0, cumulLosses: 0, cumulPp: 0, cumulPa: 0};
    let p1player = playerStats.find(p => p.playerId === p1id);
    let p2player = playerStats.find(p => p.playerId === p2id);
   	let p1Stats = (p1player) ? p1player.rounds[roundIdx] : defaultStats;
   	let p2Stats = (p2player) ? p2player.rounds[roundIdx] : defaultStats;

   	// ScoreEdit props
		// m.scoreEditProps = {editedByTeam: "B", opponentApproval: false};
   	const { scoreEditProps } = matchup;
   	let scoreEditMark = "";
   	let scoreEditCss = "";

   	if ((scoreEditProps.editedByTeam != null) && (scoreEditProps.editedByTeam !== editorPlayer.team)) {
 			if (scoreEditProps.opponentApproval) {
				scoreEditMark = "✓";
				scoreEditCss = "checkMark";   		
 			} else {
				scoreEditMark = "!";
				scoreEditCss = "bangMark";   				
 			}
  	}

  	const showValidationPopup = 
		 (scoreValidationPopup.show && (scoreEditMark !== "") &&
     (scoreValidationPopup.roundIdx === roundIdx) && 
     (scoreValidationPopup.matchupIdx === matchupIdx));

		return (
			<div className="ss2-rnd-matchup-box" key={"roundmatch-" + roundIdx + "-" + matchupIdx}>
			<div className="ss2-rnd-player-box">
        {/* BREAK */}
				<div className="ss2-rnd-box1 t1">
					{(matchup.breakTeamIdx === 1) 
						?	<span className="ss2-rnd-match-break">B</span>
						: null}
				</div>

				<div className="ss2-rnd-box2">
					<span className="ss2-playerIdxTag">A{matchup.p1Index[0] + 1}</span>
		      {editMode ? (
            <select
            	className="ss2-rnd-box2-pointer ss2-rnd-box2-select form-control form-control-sm input-sm"
              value={matchup.p1player[0].playerId}
              onChange={(e) => this.handlePlayerChange(roundIdx, matchupIdx, 1, e, false, null)} >
							<option key='tp1-empty' value={"0"}>{CST_NOPLAYER}</option>
	            {team1players.map((tp, tpIdx) => this.teamPlayersOptions(1, tp, tpIdx))}
	            <option key='tp1-sub' value='selectSub'>++ Substitut</option>
            </select>
	        ) : (
	          <span> {p1name} </span>
	        )}

	        <br/>

					<span className="ss2-rnd-text-pstats"> TRS {matchup.p1player[0].rating} </span>
					<span className="ss2-rnd-text-pstats2 fa fa-bar-chart">&nbsp;&nbsp;
						{p1Stats.cumulWins}-{p1Stats.cumulLosses} <strong>&nbsp;&nbsp;
							&Delta;</strong>&nbsp;{formatDiffNumber(p1Stats.cumulPp-p1Stats.cumulPa)} 
					</span>
				</div>
				<div className="ss2-rnd-box3">
        	<input className={"ss2-rnd-scorebox-score no-spinners" + specBgEditClass} type="number" pattern="[0-9]*" id="sc1" 
        		value={matchup.p1score} 
        		onFocus={this.handleFocusScore}
        		onChange={(e) => this.handleOnChangeScore(roundIdx, matchupIdx, 1, e)}
        		onBlur={(e) => this.handleOnBlurScore(roundIdx, matchupIdx, 1, e)}
        		onKeyPress={(e) => this.handleKeyPress(roundIdx, matchupIdx, 1, e)}
        		disabled={savingScoreEdit || readOnly}
        		style={readOnly ? { color: "black" } : {}} >
        	</input>

        	{/* EXAMPLE of using a circle to mark an Ero against - to fine tune*/}
        	{/*<span className="ss2-ero-circled" onClick={this.handleClickScore1}> </span>*/}
				</div>

				{/* ERO/TV BOX CONTAINER */}
				<div className="ss2-rnd-erobox-container">
          <select
          	className={"ss2-rnd-erobox-box" + specBgEditClass} id="ebox"
            value={matchup.specialPerfo} tabIndex="-1" disabled={savingScoreEdit || readOnly}
            onChange={(e) => this.handleOnChangeSpecialPerfo(roundIdx, matchupIdx, e)}>
						<option key='specperf1' value={""}></option>
						<option key='specperf2' value={"E"}>E</option>
						<option key='specperf3' value={"TV"}>TV</option>
          </select>
				</div>
			</div>

			<div className="ss2-rnd-player-box">

        {/* BREAK */}
				<div className="ss2-rnd-box1 t2">
					{(matchup.breakTeamIdx === 2) 
						?	<span className="ss2-rnd-match-break">B</span>
						: null}
				</div>

				<div className="ss2-rnd-box2">
					<span className="ss2-playerIdxTag">B{matchup.p2Index[0] + 1}</span>
		      {editMode ? (
            <select
            	className="ss2-rnd-box2-pointer ss2-rnd-box2-select form-control form-control-sm input-sm"
              value={matchup.p2player[0].playerId}
              onChange={(e) => this.handlePlayerChange(roundIdx, matchupIdx, 2, e, false, null)} >
							<option key='tp2-empty' value={"0"}>{CST_NOPLAYER}</option>
	            {team2players.map((tp, tpIdx) => this.teamPlayersOptions(2, tp, tpIdx))}
	            <option key='tp1-sub' value='selectSub'>++ Substitut</option>
             </select>
	        ) : (
	          <span> {p2name} </span>
	        )}

	        <br/>
					<span className="ss2-rnd-text-pstats"> TRS {matchup.p2player[0].rating} </span>
					<span className="ss2-rnd-text-pstats2 fa fa-bar-chart">&nbsp;&nbsp;
						{p2Stats.cumulWins}-{p2Stats.cumulLosses} <strong>&nbsp;&nbsp;
							&Delta;</strong>&nbsp;{formatDiffNumber(p2Stats.cumulPp-p2Stats.cumulPa)} 
					</span>
				</div>
				<div className="ss2-rnd-box3">
	      	<input className={"ss2-rnd-scorebox-score no-spinners" + specBgEditClass} type="number" pattern="[0-9]*" id="sc2" 
        		value={matchup.p2score}
        		onFocus={this.handleFocusScore}
						onChange={(e) => this.handleOnChangeScore(roundIdx, matchupIdx, 2, e)}
        		onBlur={(e) => this.handleOnBlurScore(roundIdx, matchupIdx, 2, e)}
        		onKeyPress={(e) => this.handleKeyPress(roundIdx, matchupIdx, 2, e)}
        		disabled={savingScoreEdit || readOnly}
        		style={readOnly ? { color: "black" } : {}} >
 	      	</input>
				</div>
			</div>

			{/* SCORE EDIT PROP DISPLAY */}
			{ !readOnly ? (
			<div className={`ss2-rnd-scoreEditProps-container ${scoreEditCss}`} 
				onClick={() => this.handleClickMark(roundIdx, matchupIdx)}>

        <span className={`ss2-rnd-scoreEditProps ${scoreEditCss}`}> {scoreEditMark} </span>
	      {showValidationPopup && (
	        <div className="ss2-popup-container" ref={this.scoreValidationPopupRef}>
	        <div className="ss2-popup">
	          <button className="ss2-popup-btn-validate" 
	          	onClick={(e) => this.handleApproveRejectScore(roundIdx, matchupIdx, true, e) }>
	          	Valider
	          </button>
	          <button className="ss2-popup-btn-reject" 
	          	onClick={(e) => this.handleApproveRejectScore(roundIdx, matchupIdx, false, e)}>
	          	Rejeter
	          </button>
	        </div>
	        </div>
	     	)}
			</div>
			) : null }

			<hr className="ss2-hr-match"/>
			</div>			
		)
	}

	teamPlayersOptions = (teamIdx, tp, tpIdx) => {
	  const displayName = tp.name + (tp.isSub ? ' (SUB)' : '');
	  return (
	    <option key={`tp${teamIdx}-${tpIdx}`} value={tp._id}>
	      {displayName}
	    </option>
	  );
	};

	showRoundSummary(roundIdx, e) {
		const { teamStats } = this.state;

		let tm1RndBoxClass = "";	// empty
		if (teamStats[0].rounds[roundIdx].rndPt === 0.5) {
			tm1RndBoxClass += " half";
		} else if (teamStats[0].rounds[roundIdx].rndPt === 1) {
			tm1RndBoxClass += " full";			
		}

		let tm2RndBoxClass = "";	// empty
		if (teamStats[1].rounds[roundIdx].rndPt === 0.5) {
			tm2RndBoxClass = " half";
		} else if (teamStats[1].rounds[roundIdx].rndPt === 1) {
			tm2RndBoxClass = " full";			
		}

		return (
			<div className="ss2-rndsum-box">
				<div className="ss2-rndsum-box2">
				<div className="ss2-rndsum-title">
					RONDE
				</div>

				<table className="ss2-rndsum-table">
				<tbody>
					<tr>
						<td className="ss2-rndsum-hdr"> <span> STOT </span> </td>
						<td className="ss2-rndsum-hdr"> <span> HCP </span> </td>
						<td className="ss2-rndsum-hdr"> <span> TOT </span> </td>
						<td className="ss2-rndsum-hdr"> <span> RD </span> </td>
						<td className="ss2-rndsum-hdr"> <span> CUMUL </span> </td>
					</tr>
					<tr>
						<td className="ss2-rndsum-td"> <span className="ss2-rndsum-col"> {teamStats[0].rounds[roundIdx].pp} </span> </td>
						<td className="ss2-rndsum-td ss2-rndsum-td-hdcp"> <span className="ss2-rndsum-col"> {teamStats[0].rounds[roundIdx].hdcpPoints} </span> </td>
						<td className="ss2-rndsum-td"> <span className="ss2-rndsum-col"> {teamStats[0].rounds[roundIdx].ppTot} </span> </td>
						<td className="ss2-rndsum-td ss2-rndsum-td-rndbox"> <span className={"ss2-rndsum-col ss2-rndsum-col-rndbox" + tm1RndBoxClass}> </span> </td>
						<td className="ss2-rndsum-td ss2-rndsum-td-cumul"> <span className="ss2-rndsum-col"> {teamStats[0].rounds[roundIdx].cumulPpTot} </span> </td>
					</tr>
					<tr>
						<td className="ss2-rndsum-td"> <span className="ss2-rndsum-col"> {teamStats[1].rounds[roundIdx].pp} </span> </td>
						<td className="ss2-rndsum-td ss2-rndsum-td-hdcp"> <span className="ss2-rndsum-col"> {teamStats[1].rounds[roundIdx].hdcpPoints} </span> </td>
						<td className="ss2-rndsum-td"> <span className="ss2-rndsum-col"> {teamStats[1].rounds[roundIdx].ppTot} </span> </td>
						<td className="ss2-rndsum-td ss2-rndsum-td-rndbox"> <span className={"ss2-rndsum-col ss2-rndsum-col-rndbox" + tm2RndBoxClass}> </span> </td>
						<td className="ss2-rndsum-td ss2-rndsum-td-cumul"> <span className="ss2-rndsum-col"> {teamStats[1].rounds[roundIdx].cumulPpTot} </span> </td>
					</tr>
				</tbody>
				</table>

				</div>
			</div>
		)
	}

	showMatchSummaryA() {
		const { teamStats } = this.state;

		let tm1RndBoxClass = "";	// empty
		if (teamStats[0].matchPt === 0.5) {
			tm1RndBoxClass += " half";
		} else if (teamStats[0].matchPt === 1) {
			tm1RndBoxClass += " full";
		}

		let tm2RndBoxClass = "";	// empty
		if (teamStats[1].matchPt === 0.5) {
			tm2RndBoxClass += " half";
		} else if (teamStats[1].matchPt === 1) {
			tm2RndBoxClass += " full";
		}

		return (
			<div className="ss2-matchsum-box">
				<div className="ss2-matchsum-box2">
				<div className="ss2-matchsum-title"> MATCH </div>

				<table className="ss2-matchsum-table">
				<tbody>
					<tr>
						<td className="ss2-matchsum-hdr"> <span> </span> </td>
						{teamStats[0].rounds.map(this.dispMatchSummaryRoundsHdr) }
						<td className="ss2-matchsum-hdr"> <span> </span> </td>
						<td className="ss2-matchsum-hdr"> <span> M </span> </td>
					</tr>

					<tr>
						<td className="ss2-matchsum-td ss2-matchsum-td1"> <span className="ss2-matchsum-col1"> LOC </span> </td>
						{teamStats[0].rounds.map((msr, idx) => this.dispMatchSummaryRoundsPts(0, msr, idx)) }

						<td className="ss2-matchsum-td ss2-matchsum-td-separator"> 
							<span className={"ss2-matchsum-col ss2-matchsum-col-separator"}> </span>
						</td>

						<td className="ss2-matchsum-td ss2-matchsum-td-rndbox"> 
							<span className={"ss2-matchsum-col ss2-matchsum-col-rndbox" + tm1RndBoxClass}> </span>
						</td>

					</tr>
					<tr>
						<td className="ss2-matchsum-td ss2-matchsum-td1"> <span className="ss2-matchsum-col1"> VIS </span> </td>
						{teamStats[1].rounds.map((msr, idx) => this.dispMatchSummaryRoundsPts(1, msr, idx)) }

						<td className="ss2-matchsum-td ss2-matchsum-td-separator"> 
							<span className={"ss2-matchsum-col ss2-matchsum-col-separator"}> </span>
						</td>

						<td className="ss2-matchsum-td ss2-matchsum-td-rndbox"> 
							<span className={"ss2-matchsum-col ss2-matchsum-col-rndbox" + tm2RndBoxClass}> </span>
						</td>

					</tr>
				</tbody>
				</table>
				</div>
			</div>
		)
	}

	dispMatchSummaryRoundsPts(tIdx, msr, msrIdx) {
		let tmRndBoxClass = "";	// empty
		if (msr.rndPt === 0.5) {
			tmRndBoxClass += " half";
		} else if (msr.rndPt === 1) {
			tmRndBoxClass += " full";			
		}
		return (
			<td key={"dmatchSumRdPts-" + tIdx + "-" + msrIdx} className="ss2-matchsum-td ss2-matchsum-td-rndbox"> 
				<span className={"ss2-matchsum-col ss2-matchsum-col-rndbox" + tmRndBoxClass}> </span>
			</td>
		)
	}

	showMatchSummaryB() {
		const { teamStats } = this.state;
		return (
			<div className="ss2-matchsum-box">
				<div className="ss2-matchsum-box2">
				<table className="ss2-matchsum-table">
				<tbody>
					<tr>
						<td className="ss2-matchsum-hdr"> <span> </span> </td>
						<td className="ss2-matchsum-hdr ss2-matchsum-hdr-cumul"> <span> SOUS-TOTAL </span> </td>
						<td className="ss2-matchsum-hdr ss2-matchsum-hdr-cumul"> <span> HANDICAP </span> </td>
						<td className="ss2-matchsum-hdr ss2-matchsum-hdr-cumul"> <span> TOTAL </span> </td>
						<td className="ss2-matchsum-hdr ss2-matchsum-hdr-rdpt"> <span> RÉSULTAT </span> </td>
					</tr>

					<tr>
						<td className="ss2-matchsum-td ss2-matchsum-td1"> <span className="ss2-matchsum-col1"> LOC </span> </td>
						<td className="ss2-matchsum-td ss2-matchsum-td-cumul"> 
							<span className={"ss2-matchsum-col ss2-matchsum-col-cumul"}> {teamStats[0].points} </span>
						</td>
						<td className="ss2-matchsum-td ss2-matchsum-td-hdcp"> 
							<span className={"ss2-matchsum-col ss2-matchsum-col-cumul"}> {teamStats[0].totalHdcpPoints} </span>
						</td>
						<td className="ss2-matchsum-td ss2-matchsum-td-cumul"> 
							<span className={"ss2-matchsum-col ss2-matchsum-col-cumul"}> {teamStats[0].totalPoints} </span>
						</td>
						<td className="ss2-matchsum-td ss2-matchsum-td-rdpt"> 
							<span className={"ss2-matchsum-col ss2-matchsum-col-rdpt"}> {teamStats[0].totalRoundPts} </span>
						</td>
					</tr>
					<tr>
						<td className="ss2-matchsum-td ss2-matchsum-td1"> <span className="ss2-matchsum-col1"> VIS </span> </td>
						<td className="ss2-matchsum-td ss2-matchsum-td-cumul"> 
							<span className={"ss2-matchsum-col ss2-matchsum-col-cumul"}> {teamStats[1].points} </span>
						</td>
						<td className="ss2-matchsum-td ss2-matchsum-td-hdcp"> 
							<span className={"ss2-matchsum-col ss2-matchsum-col-cumul"}> {teamStats[1].totalHdcpPoints} </span>
						</td>
						<td className="ss2-matchsum-td ss2-matchsum-td-cumul"> 
							<span className={"ss2-matchsum-col ss2-matchsum-col-cumul"}> {teamStats[1].totalPoints} </span>
						</td>
						<td className="ss2-matchsum-td ss2-matchsum-td-rdpt"> 
							<span className={"ss2-matchsum-col ss2-matchsum-col-rdpt"}> {teamStats[1].totalRoundPts} </span>
						</td>
					</tr>
				</tbody>
				</table>
				</div>
			</div>
		)
	}

	showMatchValidation() {
		const { readOnly } = this.state;
		return (
			<div className="ss2-validation-box">
			<div className="ss2-validation-block">
				{!readOnly ? (
					<input type="button" className="btn btn-primary ss2-validate-btn" 
						value="Terminer et Valider le match" onClick={this.handleValidateClick} />
				) : (
					<input type="button" className="btn btn-primary ss2-validate-btn" 
						value="Quitter" onClick={this.handleQuitClick} />
					)
				}
			</div>
			</div>
		)
	}

	dispMatchSummaryRoundsHdr(msr, msrIdx) {
		return (
			<td key={"dmatchSumRdHdr-" + msrIdx} className="ss2-matchsum-hdr"> 
				<span> {msrIdx + 1} </span>
			</td>
		)
	}

	handleMatchDatePickClick = () => {
		//console.log("handleMatchDate - CLICK")
		this.setState({ showMatchDatePicker: true });
	}
	handleMatchDatePickerOnBlur = (e) => {
		//console.log("handleMatchDate - BLUR")
		let { match } = this.state;
		match.datePlayed = e.target.value;
		this.setState({ match, showMatchDatePicker: false	}, 
			this.saveScoresheetParameters()
		);
	}
	handleMatchDateChange = (e) => {
		//console.log("handleMatchDate - CHANGE")
		let { match } = this.state;
		match.datePlayed = e.target.value;
		this.setState({ match	});
	}

	handleRoundScroll(opt) {
    const { windowWidth, scoresheetFormat: { rounds } } = this.state;
    const roundsCount = windowWidth < CST_SCREEN_LIMIT ? 1 : Math.min(rounds.length, 3);

    let { leftMostRoundIdxShown } = this.state;
		leftMostRoundIdxShown = Math.max(Math.min((leftMostRoundIdxShown + opt), (rounds.length - roundsCount)), 0);
		
		this.refreshMatch();
		this.setState({	
			leftMostRoundIdxShown: leftMostRoundIdxShown,
		}, () => {
	    setTimeout(() => {
        this.setState({ scrollArrowsVisible: true });
	    }, 700);
		});
	}

	handlePlayerChange = (roundIdx, matchupIdx, teamIdx, e, isSub, team) => {
	  console.log("TAG handlePlayerChange");
	  // console.log(roundIdx, matchupIdx, teamIdx, e)

	  const newId = e.target.value;		// either regular player or sub

	  // Gestion substitut
	  if (newId === 'selectSub') {
	    this.setState({
	      showSubModal: true,
	      subRoundIdx: roundIdx,
	      subMatchupIdx: matchupIdx,
	      subTeamIdx: teamIdx
	    });
	    return;
	  }

	  let { match, multiEditMode } = this.state;
	  const teamKey = teamIdx === 1 ? 'p1' : 'p2';
	  const playerIdx = match.rounds[roundIdx].matchups[matchupIdx][`${teamKey}Index`][0];

    // Add in match for DB save
    if (isSub) {
			const subPlayer = { _id: newId, team: team ?? "A" };
			if (!match.subPlayers) match.subPlayers = [];
			const exists = match.subPlayers.some(sp => sp._id === subPlayer._id);
			if (!exists) {
			  match.subPlayers.push(subPlayer);
			}		
		}

	  // Mettre à jour ce matchup
	  match.rounds[roundIdx].matchups[matchupIdx][`${teamKey}player`][0].playerId = newId;

	  // Multi-édition → propager
	  if (multiEditMode) {
	    match.rounds.forEach(r => {
	      r.matchups.forEach(m => {
	        if (m[`${teamKey}Index`][0] === playerIdx) {
	          m[`${teamKey}player`][0].playerId = newId;
	        }
	      });
	    });
	  }

	  // Ensuite → recalcul complet
	  const savingType = multiEditMode ? "allPlayersChange" : "playerChange";
	 	this.saveScoresheetChange(match, roundIdx, matchupIdx, savingType);
		//this.updateScores(match, this.state.matchDetails, (updatedMatch) => {
		//	this.saveScoresheetChange(updatedMatch, roundIdx, matchupIdx, savingType);
		//});
	}

	handleSelectSubPlayer = (playerId, genericSubPlayerNotes) => {
		console.log('TAG handleSelectSubPlayer');
	  const { match, subRoundIdx, subMatchupIdx, subTeamIdx } = this.state;
    const team = (subTeamIdx === 1) ? 'A' : 'B';

    // Sauvegarde de la note SI non vide
    if (genericSubPlayerNotes && genericSubPlayerNotes.trim() !== "") {
      Axios.post('/api/scoresheets2/saveScoresheetNotes', {
   	    ssid: match._id,
        notes: genericSubPlayerNotes
      }).catch(err => {
        console.error('Erreur saveScoresheetNotes', err);
      });
    }

    this.setState({ showSubModal: false }, () => {
      this.handlePlayerChange(subRoundIdx, subMatchupIdx, subTeamIdx, { target: { value: playerId } }, true, team);
    });
	}

	handleOnChangeSpecialPerfo = (roundIdx, matchupIdx, e) => {
		console.log('TAG handleOnChangeSpecialPerfo')
		// console.log(e.target.value)

	  let { match, editMode } = this.state;
	  let matchup = match.rounds[roundIdx].matchups[matchupIdx];
		if (editMode) {
			let ans = window.confirm("Vous êtes en mode édition, quitter ce mode pour modifier les pointages.")
		} else {
			matchup.specialPerfo = e.target.value;
			this.updateScores(match, this.state.matchDetails, (updatedMatch) => {
				this.saveScoresheetChange(updatedMatch, roundIdx, matchupIdx, "specialPerfoChange");
			});
		}
	}

	// Set focus at the end of the score number when editing
  handleFocusScore = (e) => {
	  const input = e.target;
	  const { editMode } = this.state;

		if (editMode) {
			let ans = window.confirm("Vous êtes en mode édition, quitter ce mode pour modifier les pointages.")
			e.target.blur();
		} else {
		  setTimeout(() => {
		    const value = input.value; 	// Stocker la valeur actuelle
		    input.value = ''; 					// Effacer la valeur pour 'réinitialiser' le curseur
		    input.value = value; 				// Remettre la valeur, ce qui place le curseur à la fin
		  }, 1);
		}
  }

	handleOnChangeScore = (roundIdx, matchupIdx, teamIdx, e) => {
		console.log('TAG handleOnChangeScore')

	  let { match } = this.state;
	  let matchup = match.rounds[roundIdx].matchups[matchupIdx];
		this.scoreValueChanged = true;

	  const teamKey = teamIdx === 1 ? 'p1' : 'p2';
	  matchup[`${teamKey}score`] = e.target.value;
		this.setState({	match: match });
	}

	handleOnBlurScore = (roundIdx, matchupIdx, teamIdx, e) => {
		console.log('TAG handleOnBlurScore')
		// console.log(e.target.value);

		if (!this.scoreValueChanged) { return; }
		this.scoreValueChanged = false;

		this.setState({ savingScoreEdit: true });

    const { scoresheetFormat: { winPoints }, autoWinScoreMode } = this.state;
	  let { match } = this.state;
	  let matchup = match.rounds[roundIdx].matchups[matchupIdx];

	  const teamKey = teamIdx === 1 ? 'p1' : 'p2';
	  const oppTeamKey = teamIdx === 1 ? 'p2' : 'p1';
	  let scoreValue = e.target.value;

	  //console.log('scoreValue', scoreValue, typeof scoreValue)

	  if ((scoreValue !== undefined) && (scoreValue !== '')) {
	  	scoreValue = parseInt(scoreValue);
		  scoreValue = Math.max(scoreValue, 0);
		  if (winPoints !== 0) {
			  scoreValue = Math.min(scoreValue, winPoints);

			  // Set 10 to opponent if winPoints is set
			  if (autoWinScoreMode && (scoreValue !== winPoints)) {
				  matchup[`${oppTeamKey}score`] = winPoints;
				  matchup[`${oppTeamKey}scoreStatus`] = 'set';
			  }
		  }
		  matchup[`${teamKey}score`] = scoreValue;
		  matchup[`${teamKey}scoreStatus`] = 'set';
	  } else {
		  matchup[`${teamKey}scoreStatus`] = 'unset';	  	
	  }

		this.updateScores(match, this.state.matchDetails, (updatedMatch) => {
			this.saveScoresheetChange(updatedMatch, roundIdx, matchupIdx, "scoreChange");
		});
	}

	handleKeyPress = (roundIdx, matchupIdx, teamIdx, e) => {
		if (e.key === "Enter") {
			e.preventDefault();
	    const { scoresheetFormat: { winPoints } } = this.state;
		  let { match } = this.state;
		  let matchup = match.rounds[roundIdx].matchups[matchupIdx];
		  const teamKey = teamIdx === 1 ? 'p1' : 'p2';
		  matchup[`${teamKey}score`] = winPoints;
		  matchup[`${teamKey}scoreStatus`] = 'set';

			this.updateScores(match, this.state.matchDetails, (updatedMatch) => {
				this.saveScoresheetChange(updatedMatch, roundIdx, matchupIdx, "scoreChange");
			});
		}
	}

	handleClickMark = (roundIdx, matchupIdx) => {
		// console.log('handleClickMark');
		let { scoreValidationPopup } = this.state;
		scoreValidationPopup = { show: true, roundIdx: roundIdx, matchupIdx: matchupIdx };
		this.setState({ scoreValidationPopup });
	}

	handleApproveRejectScore = (roundIdx, matchupIdx, approve, e) => {
		e.stopPropagation()
	  const match = { ...this.state.match };
  	const matchup = match.rounds[roundIdx].matchups[matchupIdx];

	  // Rien n'a changé
	  if (matchup.scoreEditProps.opponentApproval === approve) {
	    this.setState({ scoreValidationPopup: { show: false } });
	    return;
	  }

	  // ⭐ Optimistic UI minimaliste : on ne modifie QUE la propriété qui change
	  matchup.scoreEditProps = {
	    ...matchup.scoreEditProps,
	    opponentApproval: approve
	  };

	  // ⭐ 1 seul setState immédiat
	  // this.setState({ match, scoreValidationPopup: { show: false } });
	  this.setState({ scoreValidationPopup: { show: false } });

	  // ⭐ Appel backend
	  Axios.post('/api/scoresheets2/approveRejectMatchupChange', {
	    ssid: match._id,
	    editorPlayer: this.state.editorPlayer,
	    roundIdx,
	    matchupIdx,
	    approve
	  }).then(response => {
	      const reloadedMatch = response.data.scoresheet;

	      // ⭐ Important : réinjecter ratings & recalculer
	      this.updateScores(reloadedMatch, this.state.matchDetails);
	    })
	    .catch(err => console.error(err));
	};

	handleValidateClick = () => {
		console.log('TAG handleValidateClick');

		const { match, editorPlayer } = this.state;
 		Axios.post('/api/scoresheets2/compileScoresheet', {
			ssid: match._id,
			editorPlayer: editorPlayer			
		})
		.then(response => {
			console.log('Scoresheet dummy Match saved !')
			console.log(response.data)

			console.warn("DEBUG: RETURN TO LIST SKIPPED");
			// const path = '/liveScoresheets/' + this.props.params.seasonTag;
			// this.props.navigate(path);		
		})
	}

	handleQuitClick = () => {
		const path = '/liveScoresheets/' + this.props.params.seasonTag;
		this.props.navigate(path);		
	}

	// ----------------------------------------------------------------------------------
	// --------------------------- TEST AND DEBUG SECTION -------------------------------
	// ----------------------------------------------------------------------------------
	handleTestFillTeams = () => {
		console.log("TESTS handleTestFillTeams")		

		let { match, matchDetails } = this.state;
		for (let pIdx = 0; pIdx < 4; pIdx++) {
	    this.updatePlayerIdInAllMatchups(match, "p1", pIdx, matchDetails.matchPlayersList[pIdx]._id);
	    this.updatePlayerIdInAllMatchups(match, "p2", pIdx, matchDetails.matchPlayersList[pIdx + 4]._id);
		}
		//match = updatePlayerRatings({...match}, matchDetails.matchPlayersList);
		this.updateScores(match, matchDetails, (updatedMatch) => {
			this.saveWholeMatch(updatedMatch);
		});
  }

	updatePlayerIdInAllMatchups(match, teamKey, playerIdx, newPlayerId) {
		console.log('TAG updatePlayerIdInAllMatchups')
	  match.rounds.forEach(r => {
	    r.matchups.forEach(m => {
	      if (m[`${teamKey}Index`][0] === playerIdx) {						// p1Index OR p2Index
	        m[`${teamKey}player`][0].playerId = newPlayerId;			// p1player OR p2player
	      }
	    });
	  });
	}

	handleTestSetScores = () => {
		console.log('TESTS handleTestSetScores');

		let { match } = this.state;
		match.rounds.forEach(r => {
			r.matchups.forEach(m => {
				let loserScore = Math.floor(Math.random() * 7);
				let winnerA = (Math.random() > 0.5);
				if (winnerA) {
					m.p1score = 10;
					m.p2score = loserScore;
				} else {
					m.p1score = loserScore;						
					m.p2score = 10;
				}
				let specProbability = Math.max(0, Math.min(1, 0.75 - 0.225 * loserScore));
				if (Math.random() < specProbability) {
					m.specialPerfo = (Math.random() > 0.7 ? 'E': 'TV')
				}
				m.p1scoreStatus = 'set';
				m.p2scoreStatus = 'set';

			});
		});

		this.updateScores(match, this.state.matchDetails, (updatedMatch) => { 
			this.saveWholeMatch(updatedMatch); 
		});
	}

	// Calcule le nouveau match avec stats et ratings, setState avec résultats, callback avec updatedMatch
	updateScores(matchArg, matchDetailsArg, callback) {
		console.log('TAG *** updateScores ***');
		// console.log(matchArg, matchDetailsArg);

		let { hasNDratingMsgDisplayed } = this.state;
    const match = matchArg ?? prev.match;
    const matchDetails = matchDetailsArg ?? prev.matchDetails;

    // Sécurité : on ne fait rien tant que matchPlayersList n’est pas prêt
    if (!matchDetails || !matchDetails.matchPlayersList) {
      console.warn("updateScores ignoré : matchPlayersList absent");
      return null;
    }

    const season = matchDetails.season ?? {};

    // 1) Obtenir les ratings à partir de matchPlayersList
    const matchWithRatings = updatePlayerRatings({ ...match }, matchDetails.matchPlayersList);
		// console.log("matchWithRatings", matchWithRatings);

    // 2) Calcul complet (besoin des ratings pour handicaps, sous-totaux et totaux)
    const { updatedMatch, playerStats, teamStats, hasNDrating } = calculateScores(matchWithRatings, matchDetails, season);
		// console.log("updatedMatch", updatedMatch);

    console.log("hasNDrating", hasNDrating)
    if (hasNDrating) {
    	if (!hasNDratingMsgDisplayed) {
    		alert("Il y a un joueur sans cote, le calcul de handicap ne sera pas adéquat.\n" +
    			"Utiliser un Substitut TRS XX et contacter Pascal Grenier pour l'aviser.")
    		hasNDratingMsgDisplayed = true;
    	}
    } else {
    	hasNDratingMsgDisplayed = false;
    }

		this.setState({
	    match: updatedMatch,
	    playerStats,
	    teamStats,
	    hasNDratingMsgDisplayed,
	    savingScoreEdit: false
	  }, () => {
	    if (callback) {
	      callback(updatedMatch);
	    }
	  });
	}

	saveScoresheetChange(match, roundIdx, matchupIdx, updateType) {
		console.log('TAG saveScoresheetChange');

	  const { editorPlayer } = this.state;
	  const data = (updateType === "allPlayersChange")
	    ? { match, subPlayers: match.subPlayers ?? [] }
	    : { roundIdx, matchupIdx, matchup: match.rounds[roundIdx].matchups[matchupIdx], subPlayers: match.subPlayers ?? [] };

	  Axios.post('/api/scoresheets2/saveScoresheetChange', {
	    ssid: match._id, 
	    editorPlayer, 
	    data, 
	    updateType 
	  })
	  .then((res) => {
	  	const reloadedMatch = res.data.scoresheet;

	  	console.log("saveScoresheetChange match", reloadedMatch)

			this.updateScores(reloadedMatch, this.state.matchDetails);
			this.refreshPlayersList();

	  })
	  .catch(err => console.error(err));
	}

	saveScoresheetParameters(matchArg) {
		console.log('TAG saveScoresheetParameters');
		// console.log(matchArg);

    const match = (matchArg !== undefined) ? matchArg : this.state.match;
    const parameters = { datePlayed: match.datePlayed };

		Axios.post('/api/scoresheets2/saveScoresheetParameters', {
			ssid: match._id,
			parameters: parameters
		})
		.then(response => {
			//console.log('Scoresheet parameters saved')
			//console.log(response.data)
			//let reloadedMatch = response.data.scoresheet;
			//this.setState({ 
			//	match: reloadedMatch
			//});
		})
		.catch(function(error) {
			callback(match);
		});
	}

	saveWholeMatch(match) {
		console.log('TAG saveWholeMatch');
		// console.log(match)

 		Axios.post('/api/scoresheets2/saveScoresheet', {
			scoresheet: match
		})
		.then(response => {
			console.log('Scoresheet dummy Match saved !')
	  	this.refreshPlayersList();
		})
	}

	refreshMatch = () => {
		console.log('TAG refreshMatch');

		const { match, matchDetails } = this.state;
		Axios.get(`/api/scoresheets2/id/${match._id}`)
		.then(responseScoresheet => {
			let reloadedMatch = responseScoresheet.data;
			this.updateScores(reloadedMatch, matchDetails);
		});
	}

}

export default withRouter(Scoresheet);